import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgDraftOrderItemsComponent } from './atg-draft-order-items.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { AtgDraftOrderItemModule } from './atg-draft-order-item/atg-draft-order-item.module';
import { KnBrDraftOrderItemModule } from 'src/feature-libs/kn-br-cart/saved-carts/components/kn-br-draft-order/kn-br-draft-order-detail/kn-br-draft-order-items/kn-br-draft-order-item/kn-br-draft-order-item.module';
import { KnBrQuoteReferenceModule } from 'src/feature-libs/kn-br-cart/saved-carts/components/kn-br-draft-order/kn-br-draft-order-detail/kn-br-draft-order-items/kn-br-quote-reference/kn-br-quote-reference.module';

@NgModule({
  declarations: [AtgDraftOrderItemsComponent],
  imports: [
    CommonModule,
    KnBrDraftOrderItemModule,
    I18nModule,
    KnBrQuoteReferenceModule,
    AtgDraftOrderItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrDraftOrderItemsComponent: {
          component: () => import('./atg-draft-order-items.component').then((c) => c.AtgDraftOrderItemsComponent),
        },
        KnBrDraftOrderItemsComponentReadOnly: {
          component: () => import('./atg-draft-order-items.component').then((c) => c.AtgDraftOrderItemsComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class AtgDraftOrderItemsModule {}
